module.exports = "//static.hsappstatic.net/pricing-pages-ui-components/static-1.7015/js/productIcon/images/ServiceHub_Ent.svg"